export enum FeedbackRatingSystem {
  LikeDislike = 'LikeDislike',
  Like = 'Like',
  ThreeScale = '3-scale',
  Stars = 'Stars',
}

export enum FeedbackRating {
  Like = 'like',
  Dislike = 'dislike',
}

export enum FeedbackSource {
  Guidance = 'guidance',
  Collection = 'collection',
}
